import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import styled from "styled-components";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoCloseOutline } from "react-icons/io5";
import logo from "../../assets/images/logo2.png";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    // Add or remove the 'overflow-hidden' class on the html and body based on the mobile menu state
    if (isMobileMenuOpen) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    }

    // Cleanup: restore the default overflow when the component unmounts
    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    };
  }, [isMobileMenuOpen]);

  return (
    <MainWrap>
      <Logo
        to="home"
        spy={true}
        smooth={true}
        offset={-50}
        duration={500}
      ></Logo>
      <BurgerIcon onClick={toggleMobileMenu}>
        {!isMobileMenuOpen ? (
          <Icon>
            <HamburgerIcon />
          </Icon>
        ) : (
          <Icon>
            <CloseIcon />
          </Icon>
        )}
      </BurgerIcon>
      <LinksWrap isOpen={isMobileMenuOpen}>
        <StyledLink
          to="aboutus"
          spy={true}
          smooth={true}
          offset={-150}
          duration={500}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          About Us
        </StyledLink>
        <StyledLink
          to="services"
          spy={true}
          smooth={true}
          offset={-150}
          duration={500}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Services
        </StyledLink>
        <StyledLink
          to="gallery"
          spy={true}
          smooth={true}
          offset={-100}
          duration={500}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Gallery
        </StyledLink>
        <StyledLink
          to="contactus"
          spy={true}
          smooth={true}
          offset={-100}
          duration={500}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Contact Us
        </StyledLink>
      </LinksWrap>
    </MainWrap>
  );
};

export default Navbar;

const MainWrap = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  font-family: "Montserrat", sans-serif;
  color: rgb(192, 192, 192);
`;

const Logo = styled(Link)`
  background: url(${logo});
  margin-left: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  width: 150px;
  height: 40px;
  cursor: pointer;
`;

const BurgerIcon = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  position: absolute;
  right: 25px;

  span {
    width: 30px;
    height: 3px;
    background-color: #fff;
    margin: 6px 0;
    transition: 0.4s;
  }

  @media (max-width: 767px) {
    display: flex;
  }
`;

const Icon = styled.a`
  width: 30px;
  height: 30px;
  margin: 10px;
`;

const HamburgerIcon = styled(RxHamburgerMenu)`
  height: 100%;
  width: 100%;
`;

const CloseIcon = styled(IoCloseOutline)`
  height: 100%;
  width: 100%;
`;

const LinksWrap = styled.div`
  position: absolute;
  right: 20px;
  text-align: right;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    flex-direction: column;
    padding-top: 50px;
    position: absolute;
    font-size: 20px;
    top: 100px;
    right: 0;
    width: 100%;
    height: 100vh;
    overflow: ${({ isOpen }) => (isOpen ? "hidden" : "auto")};
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
`;

const StyledLink = styled(Link)`
  margin: 0 20px;
  font-weight: bold;
  cursor: pointer;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #fff;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
  }

  &:hover:before {
    visibility: visible;
    width: 100%;
  }

  @media (max-width: 767px) {
    margin: 10px 0;
  }
`;
